import { useParams } from 'react-router-dom';
import { useCountryWarehouseListQuery } from 'api';
import { useCallback, useEffect, useState } from 'react';
import { WarehouseType } from '../index';

export const useWarehouses = () => {
  const { id } = useParams();
  const [isWarehouseModalOpen, setIsWarehouseModalOpen] = useState<boolean>(false);
  const [warehouseToEdit, setWarehouseToEdit] = useState<Omit<WarehouseType, 'countryId'> | undefined>(undefined);

  const { data = [] } = useCountryWarehouseListQuery({ countryId: id });

  const onWarehouseModalStateChange = useCallback(() => {
    setIsWarehouseModalOpen((oState) => !oState);
  }, []);

  const onWarehouseEdit = useCallback(
    (_data: WarehouseType) => {
      setWarehouseToEdit({
        id: _data?.id,
        name: _data?.name,
        streetAddress: _data?.streetAddress,
        city: _data?.city,
        state: _data?.state,
        zip: _data?.zip,
      });
      onWarehouseModalStateChange();
    },
    [onWarehouseModalStateChange]
  );

  useEffect(() => {
    if (!isWarehouseModalOpen) {
      setWarehouseToEdit(undefined);
    }
  }, [isWarehouseModalOpen]);

  return {
    onWarehouseModalStateChange,
    isWarehouseModalOpen,
    warehouseToEdit,
    onWarehouseEdit,
    data,
  };
};
